"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { BlogLayout } from "./BlogLayout";
import { MainLayout } from "./MainLayout";
import { ToolsLayout } from "./ToolsLayout";

interface GlobalLayoutProps {
  children: ReactNode;
}

export default function GlobalLayout({ children }: GlobalLayoutProps) {
  const pathname = usePathname();
  // const isBlogRoute = pathname.startsWith("/blog");

  if (pathname.startsWith("/blogs")) {
    return <BlogLayout>{children}</BlogLayout>;
  } else if (pathname.startsWith("/tools")) {
    return <ToolsLayout>{children}</ToolsLayout>;
  } else {
    return <MainLayout>{children}</MainLayout>;
  }

  // return isBlogRoute ? (
  //   <BlogLayout>{children}</BlogLayout>
  // ) : (
  //   <MainLayout>{children}</MainLayout>
  // );
}
